/**
 * 1L2C REST API
 * Specification of REST API for 1Life2Connect Project
 *
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { CategoryBasicView } from './categoryBasicView';
import { OrganizationType } from './organizationType';

export interface Organization { 
    specialty?: Array<CategoryBasicView>;
    diseases?: Array<CategoryBasicView>;
    organization_type?: OrganizationType;
    website?: string;
    alternative_names?: Array<string>;
}